import { bool, func, number, oneOf, shape, string } from 'prop-types';
import React from 'react';
import { Col, FormGroup, Input } from 'reactstrap';

import CurrencyInput from '../../../generic/CurrencyInput';
import SingleSelect from '../../../generic/SingleSelect';
import { allTargetKpis, targetKpiOptions } from './constants';

function adjustEvent(event, name, value) {
  return { target: { ...event.target, name, value } };
}

function TargetKpi({
  widths,
  targetKpi,
  targetKpiValue,
  campaignObjective,
  onChange,
  readOnly,
}) {
  const kpiOption = allTargetKpis.find(kpi => kpi.value === targetKpi);
  const KpiComponent = kpiOption?.currency ? CurrencyInput : Input;
  const kpiProps = kpiOption?.currency
    ? null
    : {
        type: 'number',
        step: '0.01',
      };
  const onChangeTargetKpi = event => {
    // When the target KPI changes, reset the target value.
    onChange(event);
    const option = allTargetKpis.find(kpi => kpi.value === event.target.value);
    onChange(adjustEvent(event, 'targetKpiValue', option.defaultValue || 0));
  };

  return (
    <FormGroup row>
      <Col sm={widths.label}>
        <SingleSelect
          options={targetKpiOptions[campaignObjective]}
          value={targetKpi}
          name="targetKpi"
          readOnly={readOnly}
          onChange={onChangeTargetKpi}
        />
      </Col>
      <Col sm={widths.content} className="d-flex align-items-baseline">
        <KpiComponent
          id="qu-targetKpiValue"
          name="targetKpiValue"
          value={targetKpiValue || 0}
          {...kpiProps}
          readOnly={readOnly}
          onChange={onChange}
        />
      </Col>
    </FormGroup>
  );
}

TargetKpi.propTypes = {
  widths: shape({ label: number.isRequired, content: number.isRequired })
    .isRequired,
  readOnly: bool.isRequired,
  targetKpi: oneOf(allTargetKpis.map(kpi => kpi.value)).isRequired,
  targetKpiValue: number,
  onChange: func,
  campaignObjective: string,
  isEditing: bool,
};
TargetKpi.defaultProps = {
  targetKpiValue: 0,
  onChange: undefined,
  campaignObjective: undefined,
  isEditing: true,
};

export default TargetKpi;
